import type { AuthContext } from '@/components/users/useAuth'
import type { QueryClient } from '@tanstack/react-query'
import { queryClient } from '@/api/provider'
import { useAuth } from '@/components/users/useAuth'
import { routeTree } from '@/routeTree.gen'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { useEffect } from 'react'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export interface RouterRootContext {
  queryClient: QueryClient
  user: AuthContext['user']
  isAuthenticated: AuthContext['isAuthenticated']
}

export const router = createRouter({ routeTree, context: {} as RouterRootContext })

export function AppChildren() {
  const { isAuthenticated, user } = useAuth()

  useEffect(() => {
    const currentPathName = window.location.pathname
    if ((currentPathName.startsWith('/editor') || currentPathName.startsWith('/admin')) && !isAuthenticated) {
      window.location.href = `/auth/login?next=${currentPathName}`
    }
  }, [isAuthenticated])

  return <RouterProvider router={router} context={{ queryClient, user, isAuthenticated }} />
}
